<script>
export default {
  props: ['fastData'],
  data () {
    return {
      posSelectOptions: [{
        value: 1,
        label: 'Ua'
      }, {
        value: 2,
        label: 'Ub'
      }, {
        value: 3,
        label: 'Uc'
      }, {
        value: 4,
        label: 'Ia'
      }, {
        value: 5,
        label: 'Ib'
      }, {
        value: 6,
        label: 'Ic'
      }, {
        value: 7,
        label: 'In'
      }],
      posSelectValue: 1,
      showFft: [],
      tableData: {}
    }
  },
  watch: {
    posSelectValue () {
      this.setValue()
    },
    fastData () {
      this.setValue(this.fastData)
    }
  },
  computed: {

  },
  mounted () {
    this.setValue()
  },
  destroyed () {
  },
  methods: {
    setValue () {
      var page = this.posSelectValue
      var data = this.fastData
      if (page === 1) {
        this.showFft = data ? data.fast_fft_ua : []
      } else if (page === 2) {
        this.showFft = data ? data.fast_fft_ub : []
      } else if (page === 3) {
        this.showFft = data ? data.fast_fft_uc : []
      } else if (page === 4) {
        this.showFft = data ? data.fast_fft_ia : []
      } else if (page === 5) {
        this.showFft = data ? data.fast_fft_ib : []
      } else if (page === 6) {
        this.showFft = data ? data.fast_fft_ic : []
      } else if (page === 7) {
        this.showFft = data ? data.fast_fft_in : []
      }
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">高速采样谐波频谱表</div>

      <div style="display: flex; flex-wrap: wrap; height: 35px; line-height: 35px; margin-bottom: 10px">
        <div style="display: flex; width: 100%;">
          <div
            style="display: flex; align-items: center; margin-left: 20px">
            <div style="width: 80px; text-align: left">电气量</div>
            <div style="width: 150px; margin-left: 10px">
              <el-select v-model="posSelectValue" placeholder="请选择" size="20px">
                <el-option
                  v-for="item in posSelectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div style="height: calc(100% - 100px); display: flex">
        <div class="dataItem" style="height: 100%; border-top: 1px solid black; width: 10%;" v-for="item in 10" :key="item">
            <div class="dataName" :style="item === 1 ? '' : 'border-left: 1px solid black'">
              <div class="dataTitle">次数</div>
              <div class="dataNvItem" v-for="i in 20" :key="i">
                {{i + (item - 1) * 20}}
              </div>
            </div>
            <div class="dataValue">
              <div class="dataTitle">百分比</div>
              <div class="dataNvItem" v-for="i in 20" :key="i">
                {{ Number(showFft[i + (item - 1) * 20 - 1]).toFixed(1) }}
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";
/*.pg{
  width: 49%;
  //height: calc(65vh - 50px);
}*/

.pg {
  width: 98%;
  height: calc(90vh - 150px);
}

.dataName {
  width: 50%;
}

.dataValue {
  width: 50%;
//border-right: 1px solid black;
}

.dataTitle {
  height: 30px;
}

.dataNvItem {
  height: calc((100% - 50px) / 20);
}

/*
.dataItem{
  width: 50%;
}
*/

</style>



// WEBPACK FOOTER //
// src/pages/Speed/SpeedThdTable/SpeedThdTable.vue